// extracted by mini-css-extract-plugin
export default {"barContainer":"TeamWorkPlanCard_barContainer__wMjhu","cardContainer":"TeamWorkPlanCard_cardContainer__yINmc"};